export enum MediaCustomizationsProperties {
  Name = 'name',
  Description = 'description',
  ContactEmail = 'contactEmail',
  DirectUrl = 'directUrl',
  SocialMediaAccounts = 'socialMediaAccounts',
  Owner = 'owner',
  Id = 'id',
  Created = 'created',
  Updated = 'updated',
  Deleted = 'deleted',
  Version = 'version',
  Profile = 'profile',
  PublishingState = 'publishingState',
  LastPublished = 'lastPublished',
}
export enum MediaCustomizationsMetaProperties {
  SocialMediaAccountsId = 'SocialMediaAccounts-id',
  SocialMediaAccountsVersion = 'SocialMediaAccounts-version',
  ProfileId = 'Profile-id',
  ProfileVersion = 'Profile-version',
}
